export const UPDATE_DISCLAIMER =
  'Your profile will take some time to update and may not be immediately displayed in your profile view.\n\nThis update was applied only in the Intermountain system and not SelectHealth systems, please call SelectHealth to update their records.';
